import React, {Component, PropTypes} from 'react';
import {observer, inject} from 'mobx-react';
import {observable, action, autorun, toJS} from 'mobx';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, {FormBody, FormActions, SelectInput, TextInput} from '../Form';
import {userPermission} from '../../actions/api';

@inject('rolePermissionStore')
@observer
class PermissionAdd extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  @observable

  slug = '/role';
  title = 'Add Permission';
  actions = [
    'view',
    'modify',
  ];

  constructor(props) {
    super(props);
    this.state = {
      resource: ''
    };
    this.handleSave = this.handleSave.bind(this);
  }

  componentWillMount(){
    this.props.rolePermissionStore.fetchDefaultPermissions();
  }

  @action onChangeResource = event => this.setState({resource: event.target.value});

  handleSave(e) {
    e.preventDefault();
    const {notify, router} = this.context;
    let json = this.actions.map(action => {
      return ({
        resource: this.state.resource,
        name: `${action} ${this.state.resource}`
      })
    });
    this.props.rolePermissionStore.addRolePermission(json)
      .then(res => {
        notify.success(res);
        router.push(this.slug);
      }).catch(notify.error);
  }

  render() {
    const {rolePermissionStore} = this.props;
    let unusedPermissions = rolePermissionStore.defaultPermissions.filter(item => !rolePermissionStore.items.find(x => x.resource === item.name))
    return (
      <Modal title={this.title} slug={this.slug}>
        <Form>
          <FormBody>
            <SelectInput label={'Resource'} value={this.state.resource} onChange={this.onChangeResource} options={unusedPermissions} fields={{label: 'name', value: 'name'}}/>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}


export default PermissionAdd;



// WEBPACK FOOTER //
// ./src/components/Permission/PermissionAdd.js